import React, { useEffect, useState } from 'react'
import UnitOverviewComponent from '../Utilities/UnitOverviewComponent/UnitOverviewComponent'
import { GetInquiryMatchedUnitDetails , UnitMatchingViewAPI  } from '../../../../../../../Services';
import {  GetParams } from '../../../../../../../Helper' ; 

const MatchedUnitOverview = ({
  unitId,
  actionButtons,
  inquiryId,
  isLease , 
  isMatchingFromLeadView , 
  saleMatching 
}) => {

  const [data, setData] = useState({});
  const leadClass = GetParams('leadClass');

   const getInquiryMatchedUnitDetails = async () => {
    const res = await GetInquiryMatchedUnitDetails(unitId);
    if (!(res && res.status && res.status !== 200)) {
      setData(res);
    }
  };
    const getMatchedUnitDetails = async () => {
      const res = await UnitMatchingViewAPI(unitId , leadClass);
      if (!(res && res.status && res.status !== 200))
        if (!(res && res.status && res.status !== 200)) {
          setData({
            ...res,
            unitImages: res.unitImages,
            unitRefNo: res?.unitReferenceNo,
            listingAgentDto: res?.listingAgentName
              ? {
                  profileImage: res?.profileImage,
                  name: res?.listingAgentName,
                  mobileNumber: res?.listingAgentMobile,
                  whatsAppNumber: res?.listingAgentWhatsApp,
                  email: res?.listingAgentEmail,
                }
              : null,
            rentListingAgent: res?.rentListingAgent,
            marketingTitle: res?.marketingTitle,
            fixtures: res?.fixtures || [],
            unitVeiw: res?.views,
            masterDeveloper: res?.developer,
            saleStatusName: res?.saleStatusName ,
            leaseStatusName: res?.leaseStatusName ,
            operationType: res?.operationType || (isLease ? "Rent" : "Sale"),
            bedroom: res?.bedrooms,
            bathroom: res?.bathrooms,
            pricePerSqft: res.pricePerSqFt,
          });
        }
    };

  useEffect(() => {
    if (unitId && !isMatchingFromLeadView) getInquiryMatchedUnitDetails();
    else if (unitId && isMatchingFromLeadView) getMatchedUnitDetails();
  }, [unitId, isMatchingFromLeadView]);

  return (
    <>
      <UnitOverviewComponent
        actionButtons={actionButtons}
        data={data}
        unitId={unitId}
        inquiryId={inquiryId}
        reload={
          !isMatchingFromLeadView
            ? getInquiryMatchedUnitDetails
            : getMatchedUnitDetails
        }
        isLease={isLease}
        isMatchingFromLeadView={isMatchingFromLeadView}
        saleMatching={saleMatching}
      />
    </>
  );
}

export default MatchedUnitOverview
